import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

export const searchDocuments = createAction(
  'SEARCH_DOCUMENTS',
  params => api.get('search', { params }),
  ({ query, page }) => ({ query, page })
);

export const getDocument = createAction(
  'GET_DOCUMENT',
  identifier => api.get(`document/${encodeURIComponent(identifier)}`),
  identifier => ({ identifier })
);

export const showDocument = createAction(
  'SHOW_DOCUMENT',
  ({ doc }) => ({ doc }),
  ({
    query,
    position,
    currentPage,
    isSuggested,
  }) => ({
    query,
    position,
    currentPage,
    isSuggested,
  }),
);

export const showPdf = createAction(
  'SHOW_PDF',
  id => ({ id }),
);

export const showFullText = createAction(
  'SHOW_FULL_TEXT',
  ({ doc }) => ({ doc }),
  ({ position, currentPage, isSuggested }) => ({ position, currentPage, isSuggested }),
);

export const documentInView = createAction('DOCUMENT_IN_VIEW');



// WEBPACK FOOTER //
// ./src/universal/ui/actions/document.js